var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "branch-provider-selection"
  }, [_c('b-button', {
    staticClass: "branch-provider-selection__open-modal-button",
    attrs: {
      "variant": "inverse-primary"
    },
    on: {
      "click": _vm.handleOpenModalButtonIsClicked
    }
  }, [_vm._v(" 選擇分店來源 ")]), _vm.isFetchingSelectedBranchModel ? _c('b-spinner', {
    staticClass: "ml-3",
    staticStyle: {
      "border-width": "1px"
    },
    attrs: {
      "small": ""
    }
  }) : _vm.selectedBranchModel ? _c('div', {
    staticClass: "branch-provider-selection__preview-selection ml-3"
  }, [_vm._v(" " + _vm._s(_vm.formattedBranchName(_vm.selectedBranchModel)) + " ")]) : _vm._e(), _c('b-modal', {
    ref: "modal",
    attrs: {
      "title": "選擇分店來源",
      "cancel-title": "取消"
    },
    on: {
      "shown": _vm.handleAreaSelectionModalIsShown,
      "ok": _vm.handleOkIsClicked,
      "cancel": _vm.handleCancelIsClicked
    }
  }, [_c('label', {
    staticClass: "d-inline-flex align-items-center mb-2"
  }, [_c('span', {
    staticClass: "mr-2",
    staticStyle: {
      "color": "#777"
    }
  }, [_vm._v("是否顯示分店代號")]), _c('b-form-checkbox', {
    attrs: {
      "value": true,
      "unchecked-value": false
    },
    on: {
      "input": function input(value) {
        return _vm.$emit('update:showBranchCode', value);
      }
    },
    model: {
      value: _vm.vModelForShowBranchCode,
      callback: function callback($$v) {
        _vm.vModelForShowBranchCode = $$v;
      },
      expression: "vModelForShowBranchCode"
    }
  })], 1), _c('AreaSelection', {
    ref: "area-selection-for-branch-provider",
    attrs: {
      "branch-provider": "waltily.branch",
      "show-branch-code": _vm.vModelForShowBranchCode,
      "placeholder": "請選擇區域",
      "api-source": "admin"
    },
    on: {
      "selected": _vm.handleAreaIsSelected
    },
    model: {
      value: _vm.currentBranchId,
      callback: function callback($$v) {
        _vm.currentBranchId = $$v;
      },
      expression: "currentBranchId"
    }
  }), _vm.currentBranchModel ? [_c('p', {
    staticClass: "mt-4 mb-2",
    staticStyle: {
      "color": "#777"
    }
  }, [_vm._v(" 請選擇分店來源： ")]), _c('div', {
    staticClass: "branch-provider-selection__candidate-branch",
    on: {
      "click": _vm.handleSelectBranchIsClicked
    }
  }, [_c('button', {
    staticClass: "branch-provider-selection__select-button",
    class: {
      'branch-provider-selection__select-button--selected': _vm.deepGet(_vm.currentBranchModel, 'branch_code') === _vm.deepGet(_vm.selectedBranchModel, 'branch_code')
    }
  }, [_c('i', {
    staticClass: "mdi mdi-24px mdi-check"
  })]), _c('span', {
    staticClass: "mx-4"
  }, [_vm._v(_vm._s(_vm.formattedBranchName(_vm.currentBranchModel)))])])] : _vm._e(), _c('p', {
    staticClass: "mt-4 mb-2",
    staticStyle: {
      "color": "#777"
    }
  }, [_vm._v(" 目前選擇的分店來源：" + _vm._s(_vm.selectedBranchModel ? '' : '尚未選擇') + " ")]), _vm.selectedBranchModel ? _c('div', {
    staticClass: "branch-provider-selection__selected-branch"
  }, [_c('button', {
    staticClass: "branch-provider-selection__clean-button",
    on: {
      "click": _vm.handleCleanSelectedBranchIsClicked
    }
  }, [_c('i', {
    staticClass: "mdi mdi-24px mdi-close"
  })]), _c('span', {
    staticClass: "mx-4"
  }, [_vm._v(_vm._s(_vm.formattedBranchName(_vm.selectedBranchModel)))])]) : _vm._e()], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }